/**
 * @file
 *
 * Handles the public Today at Elon article search interface.
 */

import jQuery from 'jquery';

const $ = jQuery;

var currentPage = 1;
var searchParams;
var searchParamsObj;
var form;
var data;

$(document).ready(function() {
	
	const sidebarSearch = document.querySelector('#newsSidebarSearchForm');
	const $sidebarSearch = $(sidebarSearch);
	
	/**
	 * Execute the search in the sidebar advanced search section
	 */
	$sidebarSearch.on('submit', function(e) {
		
		e.preventDefault();
		
		$('#search-terms').val(sanitizeHTML($('#search-terms').val()));
		window.data = $(this).serialize();
		performSearch(window.data);
		
	});
	
	/**
	 * Handle the scenario when the search results are empty on page load. For
	 * example, if someone refreshes the page after a search has been executed.
	 */
	if ($sidebarSearch.length && !$('.news-article-list article').length) {	
		
		window.data = sanitizeHTML(new URLSearchParams(window.location.search));
		performSearch(window.data);
		
	}
	
	if (sidebarSearch) {
		const resetButton = sidebarSearch.querySelector('.search-form--reset');
	
		if (resetButton) {
			const checkForInput = () => {
				const hasValue = Array.from(sidebarSearch.elements).some(field => {
					if (!field.name || field.disabled) return false;
					
					// Custom logic for #search-order
					if (field.id === 'search-order') {
						return field.value !== 'DESC'; // only count if changed from default
					}
					
					if (field.type === 'checkbox' || field.type === 'radio') {
						return field.checked;
					}
					
					return field.value && field.value.trim() !== '';
				});
	
				resetButton.style.display = hasValue ? 'inline-block' : 'none';
			};
			
			// Initial check
			checkForInput();
			
			// Native inputs and selects
			sidebarSearch.addEventListener('input', checkForInput);
			sidebarSearch.addEventListener('change', checkForInput); // catch selects
			
			// Attach to all select2-managed <select> elements inside the form
			$sidebarSearch.find('select').on('change.select2', checkForInput);
		}
	}
	
});

/**
 * Sets the styles while loading the search results 
 */
function formSetLoading(){
	$('.search-form--form').prop('disabled', true);
	$('.page-content--main').css('opacity', 0.3);
	$('#submit-search-form').css({'cursor': 'not-allowed', 'opacity': 0.3});
}

/**
 * Sets the styles after results have loaded 
 */
function formSetLoaded(){
	$('.search-form--form').prop('disabled', false);
	$('.page-content--main').css('opacity', 1.0);
	$('#submit-search-form').css({'cursor': 'pointer', 'opacity': 1.0});
}

/*
 * Sanitize the search string 
 *
 * @params string 
 * @returns string 
 */
function sanitizeHTML(str){
	return str.toString().replace(/(<([^>]+)>)/gi, "");
}

/*
 * Trigger the pagination 
 * 
 * @params int 
 */
function paginate(page){
	currentPage = page; 
	performSearch(window.data);
}

window.paginate = paginate;


/**
 * Perform a search based on parameters passed through the URL 
 * 
 * @params string 
 *
 */
function performSearch(data){
	// Show loading styles 
	formSetLoading();
	
	// Append the page to the data 
	data += "&page=" + currentPage;	
	// Perform the search request 
	$.post(elon_news_global_data.rest_search, data, function(success){})
	.fail(function(error){
		console.log(error);
	}).done(function(response){
		// Hide the loading indicator
		$('.loading-indicator').hide();

		if(response.success === true && response.data.pages > 0){
			displayResults(response.data.pages, response.data.articles);
			displayPageCount(response.data.pages);
			displayPagination(response.data.pages);
			displayPaginationArrows(response.data.pages);
		}else{
			displayNoResults();
		}
		// Set loaded styles 
		formSetLoaded();		
	});
	
	return false; 
}

/** 
 * Display the page count at the top of the page 
 * 
 * @params int pages
 */
function displayPageCount(pages){
	
	if ($('.archive--search-results')[0]) {
		
		$('.page-label--current').text('Page ' + currentPage);
		$('.page-label--total').text('of ' + pages);
		
	}
	
}

/**
 * Generate the html for the pagination link 
 * 
 * @params int 
 */
function generatePaginationHtml(pageNumber){
	
	var html = "";
	
	if(pageNumber == currentPage){
		
		html += '<span aria-current="page" class="page-numbers current">';
		html += '<span class="sr-only">Page</span>';
		html += pageNumber;
		html += '</span>';
	}else{
		html += '<a class="page-numbers" href="#" onclick="paginate(' + pageNumber + ')"><span class="sr-only">Page</span>' + pageNumber + '</a>';
	}
		
	return html;
}

/**
 * Create the HTML for the pagination arrows 
 */
function displayPaginationArrows(pages){

	var pageArrows = "";
	
	if(currentPage > 1){
		pageArrows += '<a onclick="paginate(' + (currentPage - 1) + ')">';
		pageArrows += '<i class="far fa-chevron-left" aria-hidden="true"></i>';
		pageArrows += '<span class="sr-only">Older posts</span>';
		pageArrows += '</a>';
		
	}
	
	if(currentPage < pages && pages > 1){
		pageArrows += '<a onclick="paginate(' + (currentPage + 1) + ')">';
		pageArrows += '<i class="far fa-chevron-right" aria-hidden="true"></i>';
		pageArrows += '<span class="sr-only">Newer posts</span>'; 
		pageArrows += '</a>';
	}

	$('.news-article-list--search.article-list--pagination-top>.pagination').html(pageArrows);
}

/** 
 * Display the pagination
 * 
 * @params html pagination 
 */
function displayPagination(pages){
	
	var count = 1;
	
	// Display the first 
	var pagination = "";

	if(pages > 6){ // We are only going to display up to 6 pages at a time
		
		if(currentPage < 3){ // If we are on the first three pages, only display the next two pages  
		
			while(count <= 3){ // Looping through the first three pages 
				pagination += generatePaginationHtml(count);
				count += 1;
			}
		
			pagination += '<span class=\"page-numbers dots\">&hellip;</span>'; // Adding a elipses 
			
			pagination += generatePaginationHtml(pages);

		
		}else if(currentPage > 2 && currentPage < (pages - 3)){ // If we are past the third page, but not quite 3 pages in front of the last page
			
			pagination += generatePaginationHtml(1);	 
			
			pagination += '<span class=\"page-numbers dots\">&hellip;</span>';
			
			count = currentPage - 1;
			
			while(count <= currentPage + 1){
				pagination += generatePaginationHtml(count);
				
				count++;
			}
			
			pagination += '<span class=\"page-numbers dots\">&hellip;</span>';
			
			pagination += generatePaginationHtml(pages);
		
		}else if (currentPage >= (pages-3) && currentPage != pages){ // If we are within the last three pages 
			count = currentPage - 1;
			
			pagination += '<span class=\"page-numbers dots\">&hellip;</span>';

			while(count <= currentPage + 1){
				pagination += generatePaginationHtml(count);
				count++;
			}
			
			pagination += '<span class=\"page-numbers dots\">&hellip;</span>';
			if(currentPage < pages - 2){
				pagination += generatePaginationHtml(pages);
			}

			
			
		}else{
			count = currentPage - 2;
			
			pagination += generatePaginationHtml(1);
			
			pagination += '<span class=\"page-numbers dots\">&hellip;</span>';

			while(count < currentPage){

				pagination += generatePaginationHtml(count);
				
				count++;
			}
			
			pagination +=  '<span aria-current="page" class="page-numbers current">';
			pagination += '<span class="sr-only">Page</span>';
			pagination += currentPage;
			pagination += '</span>';
		}
		
		
	}else{
		while(count <= pages){ // Looping through the first three pages 
			pagination += generatePaginationHtml(count);
			count += 1;
		}
	}
	
		
	$('.news-article-list--search.article-list--pagination-bottom').html(pagination);
	
}

/* 
 * 
 */
function displayResults(pages, articles){
	var articles_html = ""; 
	
	$.each(articles, function(k,v){
		articles_html += '<article class="article-list--item">';
		// Adding the featured image if there is one 
		if(v.featured_image){
			
			var medium_image = v.featured_image.sizes.medium; // Get the medium image for display
			
			articles_html += '<a class="article-item--media content-link-unstyled" href="' + v.permalink + '" aria-hidden="true" tabindex="-1">'; // a
			
			articles_html += '<figure class="article-item--img">'; // figure 
			
			articles_html += '<img src="' + medium_image + '" alt="">';
			
			articles_html += '</figure>'; //.article-item--img
			
			articles_html += '</a>'; // .article-item--media 
			
		}
		
		// The article text 
		articles_html += '<div class="article-item--text">';
		
		articles_html += '<h2 class="article-item--title"><a href="' + v.permalink + '">' + v.title + '</a></h2>';
		
		articles_html += '<p class="article-item--published-date">' + v.published_date + '</p>';
		
		articles_html += '<div class="article-item--summary">' + v.summary + '</div>';
		 
		articles_html += '</div>'; // .article-item--text	
		 
		articles_html += '</article>'; //.article-list--item
	});
	
	
	$('.news-article-list.news-article-list--search').html(articles_html);
}

function displayNoResults(){
	var error_msg = '<div class="article-search--error-msg">';
	error_msg += '<p><span class="fa-stack fa-3x"><i class="fad fa-newspaper fa-stack-1x" aria-hidden="true"></i><i class="fal fa-ban fa-stack-2x" aria-hidden="true"></i></span>No articles match your search criteria. Please try again.</p>';
	error_msg += '</div>';
	$('.pagination').hide();
	$('.article-list--pagination-top').hide();
	$('.news-article-list').html(error_msg);

}
window.performSearch = performSearch;
